/**
 * Custom extensions for core Backbone functions
 */

import Backbone from 'backbone';
import RSVP from 'rsvp';

const originalSync = Backbone.sync;

Backbone.sync = function (method, model, options) {
  const promise = new RSVP.Promise(function (resolve, reject) {
    const jqXhr = originalSync.call(Backbone, method, model, options);

    jqXhr.done(function (data, status, jqxhr) {
      resolve(data, status, jqxhr);
    });

    jqXhr.fail(function (jqxhr, status, errorThrown) {
      reject(jqxhr, status, errorThrown);
    });
  });

  return promise;
};
